import { render } from "./TherapyView.vue?vue&type=template&id=d78d694a&ts=true"
import script from "./TherapyView.vue?vue&type=script&lang=ts"
export * from "./TherapyView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/TherapyView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d78d694a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d78d694a', __exports__)) {
    api.reload('d78d694a', __exports__)
  }
  
  module.hot.accept("./TherapyView.vue?vue&type=template&id=d78d694a&ts=true", () => {
    api.rerender('d78d694a', render)
  })

}


export default __exports__